import {Component, ViewChild, OnInit, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import { RcpReportRest } from './rcpreport.rest';
import { SpinnerService } from '../core/services/spinner-handler/spinner-handler.service';
import { GridComponent } from '../core/shared/grid/grid.component';
import { GoupedColumn, GroupFunction } from '../core/shared/grid/grid.model';
import { RcpReportRow } from './rcpreport.model';

@Component({
    selector: 'app-rcpreport',
    templateUrl: './rcpreport.component.html',
    styleUrls: []
  })
export class RcpReportComponent {
  @ViewChild(GridComponent) grid: GridComponent;

  private headers = [
    { displayName: 'Kontrahent', propertyName: 'customerName', propertyType: 'string' },
    { displayName: 'Płatnik', propertyName: 'payerName', propertyType: 'string' },
    { displayName: 'Zgłoszenie', propertyName: 'issueTitle', propertyType: 'string' },
    { displayName: 'Zgłaszający', propertyName: 'reporterName', propertyType: 'string' },
    { displayName: 'Data rozpoczęcia pracy', propertyName: 'workStartDate', propertyType: 'date', isInitSort: true },
    { displayName: 'Opis', propertyName: 'description', propertyType: 'string', showTooltip: true },
    { displayName: 'Czas pracy', propertyName: 'invoiceTime', propertyType: 'number' },
  ];

  private columnsToGroup: GoupedColumn[] = [
    { name: 'invoiceTime', func: GroupFunction.sum }
  ];

  public rcpReportRows: RcpReportRow[];
  public isCurrentMonth: boolean = true;
  public monthFilterText: string = "bieżący";
  public expanded: boolean = true;

  constructor(
    private rest: RcpReportRest
  ) { }

  ngOnInit() {
    this.rest.getRcpReport(this.isCurrentMonth).subscribe(r => {
      this.rcpReportRows = r;
      this.grid.refreshData();
    });
  }

  public onCurrentMonthChanged(){
    console.log(this.isCurrentMonth);
    this.monthFilterText = this.isCurrentMonth ? "bieżący" : "poprzedni";
    this.rest.getRcpReport(this.isCurrentMonth).subscribe(r => {
      this.rcpReportRows = r;
      this.grid.refreshData();
    });
  }

}